import { render, staticRenderFns } from "./AddCustomField.vue?vue&type=template&id=54154de3"
import script from "./AddCustomField.vue?vue&type=script&lang=js"
export * from "./AddCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports